import React from 'react';

function Home() {
  return (
    <div style={{ backgroundColor: '#3B3B3B', minHeight: '100vh', color: 'white' }}>
      <div
        style={{
          backgroundColor: '#3B3B3B',
           color: "#FFF9DB",
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '2rem',
        }}
      >
        <h1 style={{ fontSize: '1.8rem', lineHeight: '1.6', maxWidth: '800px' }}>
          We design, build and host static websites — a complete solution to create a responsive,
          professional site for your business or project. <br /><br />
          ➢ Static web design from <u>£395</u> <br /><br />
          ➢ Bespoke graphic and logo designs from <u>£150</u> <br /><br />
          ➢ Ongoing hosting with custom web domain from <u>£8 per month</u>
        </h1>

        <h3 style={{ marginTop: '1.5rem', fontWeight: 'normal', fontSize: '1.2rem', color: ' color: "#FFF9DB"' }}>
          *These are the standard base prices which will apply in most cases
        </h3>
      </div>
    </div>
  );
}

export default Home;

